/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { AsyncPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatFooterCell,
    MatFooterCellDef,
    MatFooterRow,
    MatFooterRowDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable
} from '@angular/material/table';
import { FlexAlignDirective, FlexDirective, LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { Store } from '@ngxs/store';
import { BaseFieldComponent } from '@reports/reportContent/fields/base-field.component';
import { DataFormService } from '@reports/services/data-form.service';
import { IsolatedReportService } from '@reports/services/isolatedReport.service';
import { LoggerService } from '@shared/services/logger.service';
import { ReportContentTabularComponent } from './report-content-tabular.component';

@Component({
    selector: 'dash-gis-report-content-print-tabular',
    templateUrl: './report-content-print-tabular.component.html',
    styleUrls: [ './report-content-print-tabular.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LayoutDirective,
        LayoutAlignDirective,
        FlexDirective,
        FlexAlignDirective,
        MatTable,
        MatFooterCellDef,
        MatFooterCell,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        BaseFieldComponent,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatFooterRowDef,
        MatFooterRow,
        AsyncPipe,
        DecimalPipe
    ]
})
export class ReportContentPrintTabularComponent extends ReportContentTabularComponent {
    constructor(
        logger: LoggerService,
        isolatedReport: IsolatedReportService,
        store: Store,
        dataFormService: DataFormService
    ) {
        super(logger, isolatedReport, store, dataFormService);
    }

    protected updateColumnsToDisplay() {
        this.columnsToDisplayCache = this.definition.fields
            .filter((f) => !f.hidden && !f.disablePrint)
            .map((f) => f.name);
    }
}
